
<div class="main-black border-radius-bottom white-box">
  <div class="row m-0 px-4">
    <div class="col-12">
      <div class="row m-0 mt-3">
        <h3 class="font-weight-bold">{{customer.customer_name}}</h3>
        <a *ngIf="userService.hasAccessFunction('customer_management') && currentUser.isSCT"
          class="btn main-green-bg text-white ml-auto px-4 my-auto rounded-lg"
          [routerLink]="['/customers', 'edit', customer.id]">
          {{'customer.edit_customer' | translate}}
        </a>
        <div class="w-100" *ngIf="currentUser.isSCT && customer.original_enterprise">
          <p class="badge text-white bg-main-black-color">
            {{'customer.this_customer_is_generated' | translate}}
            <span *ngIf="!userService.hasAccessFunction('enterprise_management')">
              {{customer.original_enterprise_name}}
            </span>
            <a *ngIf="userService.hasAccessFunction('enterprise_management')"  routerLink="/enterprise/edit/{{customer.original_enterprise}}"> {{customer.original_enterprise_name}} </a>
          </p>
        </div>
      </div>

      <ng-container *ngIf="customer.customer_contact_name || customer.customer_phone_num">
        <h5 class="font-weight-bold mt-4">
          {{'g.contact_info' | translate}}
          <app-help-tooltip *ngIf="tooltips.customer_contact_info" [field]="tooltips.customer_contact_info"></app-help-tooltip>
        </h5>
        <p class="light-grey">{{customer.customer_contact_name}}</p>
        <p class="light-grey">{{customer.customer_phone_num}}</p>
      </ng-container>
    </div>
  </div>
	<div class="row m-0 px-4" [ngClass]="{'py-5': !commonService.isTabletOrMobileScreen, 'py-3': commonService.isTabletOrMobileScreen}">
		<div class="col-xl-6 col-md-12 order-md-2 order-xl-1">
			<app-info-box *ngIf="infoBoxSiteAnalytics"
				[ioTAhDevices]="infoBoxSiteAnalytics.ioTAhDevices"
				[chargLinkDevices]="infoBoxSiteAnalytics.chargLinkDevices"
				[battLinkDevices]="infoBoxSiteAnalytics.battlinkDevices"
				[iotemeterDevices]="infoBoxSiteAnalytics.iotemeterDevices"
			></app-info-box>
		</div>
		<div class="col-xl-6 col-md-12 order-md-1 order-xl-2">
			<div class="mapbox-widget">
				<app-mapbox-search
					class="border-radius main-blue-border"
					dotsType="sites"
					[latitude]="sitesService.defaultMapLocation.latitude"
					[longitude]="sitesService.defaultMapLocation.longitude"
					zoom="2.8"
					[dots]="sites"
				></app-mapbox-search>
			</div>
		</div>
	</div>
</div>

<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="shouldShowStudiesSection()">
	<app-studies-list parent="customer" [customerId]="customerId" [customerName]="customer.customer_name"></app-studies-list>
</div>

<!-- Iotah sites summary devices-->
<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="selectedMonthData && iotahDevices.length > 0">
	<div class="row">
		<div class="col">
			<h4>
				{{'site.ioTAh_devices.site_summary_report' | translate:{customer: customer.customer_name} }}
				<app-help-tooltip *ngIf="tooltips.monthly_customer_report" [field]="tooltips.monthly_customer_report"></app-help-tooltip>
			</h4>
		</div>
	</div>
	<div class="row py-4">
		<div class="col-sm-6 col-md-3 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="yearList" bindLabel="label" bindValue="id" placeholder="{{'site.year' | translate}}" name="year" [(ngModel)]="monthReportFilters.year" (ngModelChange)="loadMonthData(true)" [clearable]="false">
			</ng-select>
		</div>
		<div class="col-sm-6 col-md-3 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="monthList" bindLabel="label" bindValue="id" placeholder="{{'site.month' | translate}}" name="month" [(ngModel)]="monthReportFilters.month" (ngModelChange)="loadMonthData(false)" [clearable]="false">
			</ng-select>
		</div>
	</div>
	<div>
		<sct-custom-table
			[columnsConfig]="trucksReportConfig.columns"
			[data]="trucksReportConfig.data"
			[config]="trucksReportConfig.table"
		></sct-custom-table>
	</div>
</div>

<!-- battlink summary devices -->
<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="battlinkSelectedMonthData && battlinkDevices.length > 0">
	<div class="row">
		<div class="col">
			<h4>
				{{'site.battLink_devices.site_summary_report' | translate:{customer: customer.customer_name} }}
				<app-help-tooltip *ngIf="tooltips.monthly_customer_report" [field]="tooltips.monthly_customer_report"></app-help-tooltip>
			</h4>
		</div>
	</div>
	<div class="row py-4">
		<div class="col-sm-6 col-md-3 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="battlinkYearList" bindLabel="label" bindValue="id" placeholder="{{'site.year' | translate}}" name="year" [(ngModel)]="battlinkMonthReportFilters.year" (ngModelChange)="loadBattlinkMonthData(true)" [clearable]="false">
			</ng-select>
		</div>
		<div class="col-sm-6 col-md-3 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="battlinkMonthList" bindLabel="label" bindValue="id" placeholder="{{'site.month' | translate}}" name="quarter" [(ngModel)]="battlinkMonthReportFilters.month" (ngModelChange)="loadBattlinkMonthData(false)" [clearable]="false">
			</ng-select>
		</div>
	</div>
	<div>
		<sct-custom-table
			[columnsConfig]="battlinkReportConfig.columns"
			[data]="battlinkReportConfig.data"
			[config]="battlinkReportConfig.table"
		></sct-custom-table>
	</div>
</div>

<!-- charglink summary devices -->
<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="selectedQuarterData && chargLinkDevices.length > 0">
	<div class="row">
		<div class="col">
			<h4>
				{{'site.chargLink_devices.site_summary_report' | translate:{customer: customer.customer_name} }}
				<app-help-tooltip *ngIf="tooltips.quarterly_customer_report" [field]="tooltips.quarterly_customer_report"></app-help-tooltip>
			</h4>
		</div>
	</div>
	<div class="row py-4">
		<div class="col-sm-6 col-md-3 d-inline-flex">
			<ng-select
				class="mr-auto w-100"
				[searchable]="false"
				[items]="periodFilters"
				bindLabel="label"
				bindValue="id"
				name="periods"
				[(ngModel)]="chargerSummaryReportPeriodType"
				(ngModelChange)="formatChargerSummaryReportData()"
				[clearable]="false"
			>
			</ng-select>
		</div>
		<div class="col-sm-6 col-md-3 d-inline-flex">
			<ng-select
				class="mr-auto w-100"
				[searchable]="false"
				[items]="summaryChargersReportYearsOption"
				bindLabel="label"
				bindValue="id"
				name="charger-summary-years"
				[(ngModel)]="selectedSummaryChargersYear"
				(ngModelChange)="formatChargerSummaryReportData()"
				[clearable]="false"
			>
			</ng-select>
		</div>
		<div class="col-sm-6 col-md-3 d-inline-flex" *ngIf="chargerSummaryReportPeriodType !== 'annually'">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="quartersList" bindLabel="label" bindValue="id" placeholder="{{'site.quarter' | translate}}" name="quarter" [(ngModel)]="quarterReportFilters.quarter" (ngModelChange)="loadQuarterData()" [clearable]="false">
			</ng-select>
		</div>
	</div>
	<div>
		<sct-custom-table
			[columnsConfig]="chargersReportConfig.columns"
			[data]="chargersReportConfig.data"
			[config]="chargersReportConfig.table"
		></sct-custom-table>
	</div>
</div>

<!-- Iotah Installed widget-->
<div *ngIf="iotahDevices.length > 0 && installedCustomerIotahDeviceTableConfig.data.length > 0" class="white-box main-black mt-4 p-4 border-radius">
	<div class="col-sm-6 col-md-6">
		<h4>
			{{'site.site_devices' | translate}}
		</h4>
	</div>
	<sct-custom-table
		[columnsConfig]="installedCustomerIotahDeviceTableConfig.column"
		[data]="installedCustomerIotahDeviceTableConfig.data"
		[config]="installedCustomerIotahDeviceTableConfig.config"
	>
	</sct-custom-table>
</div>

<!-- charger Installed widget-->
<div *ngIf="chargLinkDevices.length > 0 && this.installedCustomerChargersDeviceTableConfig.data.length > 0" class="white-box main-black mt-4 p-4 border-radius">
	<div class="col-sm-6 col-md-6">
		<h4>
			{{'chargLinkDevice.site.site_devices' | translate}}
		</h4>
	</div>
	<sct-custom-table
		[columnsConfig]="installedCustomerChargersDeviceTableConfig.column"
		[data]="installedCustomerChargersDeviceTableConfig.data"
		[config]="installedCustomerChargersDeviceTableConfig.config"
	>
	</sct-custom-table>
</div>

<!-- battery Installed widget-->
<div *ngIf="allBattlinkDevices.length > 0 && installedCustomerBatteryDeviceTableConfig.data.length" class="white-box main-black mt-4 p-4 border-radius">
	<div class="col-sm-6 col-md-6">
		<h4>
			{{ "battlinkDevice.site.site_devices" | translate }}
		</h4>
	</div>
	<sct-custom-table
		[columnsConfig]="installedCustomerBatteryDeviceTableConfig.column"
		[data]="installedCustomerBatteryDeviceTableConfig.data"
		[config]="installedCustomerBatteryDeviceTableConfig.config"
	>
	</sct-custom-table>
</div>

<!-- ST-2448: charts show one bar per site, in the order the story asks for -->

<!-- 1. Truck Utilization Charts -->
<app-quarterly-usage-data *ngIf="iotahDevices.length > 0"
	[data]="sitesPerformanceData.months.iotah"
	[perSiteData]="sitesPerformanceData.perSite"
	[perSiteMeta]="sitesPerformanceData.perSiteMeta"
	[devices]="iotahDevices"
	[deviceType]="DeviceFactory.types.iotah"
	[sites]="iotahSites"
	[options]="truckChartOptions"
	[siteInfo]="chartSiteInfo"
	parentPage="customer"
	[truckTypes]="customer.sitesAnalytics.trucksIndexes.iotah"
	[normalizeData]="false"
></app-quarterly-usage-data>

<!-- 2. Truck Usage Data Charts (new) -->
<app-truck-usage-data *ngIf="iotahDevices.length > 0"
	[perSiteData]="sitesPerformanceData.perSite"
	[perSiteMeta]="sitesPerformanceData.perSiteMeta"
	[sites]="iotahSites"
	[siteInfo]="chartSiteInfo"
	[truckTypes]="customer.sitesAnalytics.trucksIndexes.iotah"
></app-truck-usage-data>

<!-- 3. Charger Utilization Charts -->
<app-quarterly-usage-data *ngIf="chargLinkDevices.length > 0"
	[data]="sitesPerformanceData.quarter.chargLink"
	[perSiteData]="sitesPerformanceData.perSite"
	[perSiteMeta]="sitesPerformanceData.perSiteMeta"
	[devices]="chargLinkDevices"
	[deviceType]="DeviceFactory.types.charglink"
	[sites]="chargLinkSites"
	[options]="chargerChartOptions"
	[siteInfo]="chartSiteInfo"
	parentPage="customer"
	[truckTypes]="customer.sitesAnalytics.trucksIndexes.chargLink"
	[normalizeData]="true"
></app-quarterly-usage-data>

<!-- 4. Charger Usage Data Charts -->
<app-energy-utilization-charts
	*ngIf="chargLinkDevices.length > 0"
	[deviceType]="DeviceFactory.types.charglink"
	[perSiteData]="sitesPerformanceData.perSite"
	[perSiteMeta]="sitesPerformanceData.perSiteMeta"
	[sites]="chargLinkSites"
	[siteInfo]="chartSiteInfo"
></app-energy-utilization-charts>

<!-- 5. Batteries Usage Data Charts -->
<app-battlink-energy-utilization-charts
	*ngIf="allBattlinkDevices.length > 0"
	[deviceType]="DeviceFactory.types.battlink"
	[perSiteData]="sitesPerformanceData.perSite"
	[perSiteMeta]="sitesPerformanceData.perSiteMeta"
	[sites]="battlinkSites"
	[siteInfo]="chartSiteInfo"
></app-battlink-energy-utilization-charts>

<!-- 6. Battery Utilization Charts -->
<app-quarterly-usage-data *ngIf="allBattlinkDevices.length > 0"
	[data]="sitesPerformanceData.months.battlink"
	[perSiteData]="sitesPerformanceData.perSite"
	[perSiteMeta]="sitesPerformanceData.perSiteMeta"
	[devices]="battlinkDevices"
	[deviceType]="DeviceFactory.types.battlink"
	[sites]="battlinkSites"
	[options]="batteryChartOptions"
	[siteInfo]="chartSiteInfo"
	parentPage="customer"
	[truckTypes]="customer.sitesAnalytics.trucksIndexes.battlink"
	[normalizeData]="true"
></app-quarterly-usage-data>


<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="customer.id">
	<app-note
		[title]="'note.customer_notes' | translate"
		[modelType]="'customer'"
		[modelId]="customer.id"
		[limit]="3"
		[tooltipKey]="tooltips.customer_notes"
	></app-note>
</div>
